module.exports = __webpack_public_path__ + "img/searchgator.a3f21e65.svg";